import React, { useState, useEffect } from "react";
import { Col, Input, Button, Row } from "antd";
import Editor from "components/Editor";
import style from "../EditDanXuan/EditDanXuan.module.scss";

export const TransInput: React.FC<{
    content: string;
    index: number;
    onChange: (index: number, content: string) => void;
}> = ({ content, index, onChange }) => {
    const [textArea, setTextArea] = useState(false);

    useEffect(() => {
        setTextArea(/<[^>]+>/g.test(content));
    }, [content]);

    return (
        <Row gutter={10} type="flex" align="middle">
            <Col span={22}>
                {!textArea && (
                    <Input
                        className={style.OptionInput}
                        placeholder="填写选项"
                        size="large"
                        onChange={e => onChange(index, e.target.value)}
                        maxLength={200}
                        value={content}
                    />
                )}
                {textArea && (
                    <Editor data={content} onBlur={e => onChange(index, e)} />
                )}
            </Col>
            <Col span={2}>
                <Button
                    icon={textArea ? "form" : "edit"}
                    onClick={() => setTextArea(!textArea)}
                />
            </Col>
        </Row>
    );
};
